module.exports = __webpack_public_path__ + "img/addon-visitor-management.50d0f34c.png";